var map = {
	"./four.svg": 46785,
	"./klarna-logo-Bottom.svg": 3670,
	"./klarna-logo-Top-mobile.svg": 10911,
	"./klarna-logo-Top.svg": 38668,
	"./one.svg": 19196,
	"./three.svg": 17295,
	"./two.svg": 78957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37499;